@if (items) {
    @if (!items.length) {
        <app-items-are-unavailable
            [itemsAreUnavailableMessage]="itemsAreUnavailableMessage"
        ></app-items-are-unavailable>
    } @else {
        <ng-content></ng-content>
    }
} @else {
    <div class="flex min-h-[200px] items-center justify-center">
        <app-loading></app-loading>
    </div>
}
